---
pageId: feature-quick-add
title: Szybkie zapisywanie wpisów
description: Szuflada szybkiego dodawania to najszybsza publiczna droga v0 do zapisania wpisu w Samlli z każdego miejsca w aplikacji.
category: features
order: 1
lang: pl
slug: funkcje/szybkie-dodawanie
updated: 2026-10-25
---

Zapisywanie powinno kosztować sekundy, nie uwagę. Szuflada szybkiego dodawania jest dostępna w całej aplikacji i wszędzie zachowuje ten sam przewidywalny przepływ sprawdzenia i zapisu.

Pasek AI wymaga osobnego włączenia zgody na karcie pokazywanej przy pierwszym użyciu; zgodę możesz później wyłączyć w **Ustawieniach → Prywatność**.

## Szuflada szybkiego dodawania

Szuflada otwiera się z wielu miejsc — z przycisku **Dodaj wpis** w górnym pasku (komputer), przycisku **+** (telefon), plusa pojawiającego się po najechaniu na wiersz osi czasu (wstępnie wypełnionego tym trackerem i czasem) albo z dowolnego pustego dnia. Skądkolwiek ją wywołasz, przepływ jest ten sam:

1. **Wybierz tryb**: **Wpis** dla wpisu z metrykami, **Notatka** dla swobodnej notatki do dziennika.
2. **Wskaż tracker** — szukaj po nazwie albo weź jeden z górnej sekcji, która podbija trackery zaplanowane na dziś w kolejności pilności. Enter bierze najlepsze dopasowanie. Każdy wiersz pokazuje ostatnią zapisaną wartość, więc masz kontekst, zanim zaczniesz pisać.
3. **Wypełnij formularz**: data i czas z przesunięciami jednym tapnięciem (**Teraz**, -15m, -1h, -1d), pole per metryka, opcjonalne tagi i notatki.
4. **Zapisz** przyciskiem **Utwórz wpis** — albo przełącz go na **Zapisz i dodaj następny**, gdy logujesz kilka rzeczy pod rząd. Preferencja zostaje zapamiętana.

Pod formularzem widzisz ostatnie wpisy trackera, więc duplikat albo literówkę łatwo wyłapać, zanim się wydarzy.

## Szkice, które przeżywają

Wszystko, co wpisujesz, jest zrzucane do szkicu, trzymanego osobno per tracker. Zamknij szufladę w połowie wpisu, wróć później — tytuł pokazuje „szkic", a Twoje wartości wracają. **Wyczyść** kasuje szkic, gdy chcesz zacząć od zera.

## Szybkie notatki

Tryb notatki pokazuje tylko trackery w trybie dziennika i zadaje jedno pytanie: co się wydarzyło? Jeśli prowadzisz jeden tracker-dziennik, jest wybierany automatycznie — otwierasz, piszesz, zapisujesz.

## Edycja i usuwanie

Najedź na wpis w Dzienniku i użyj ołówka — ta sama szuflada otwiera się w trybie edycji z akcjami **Aktualizuj wpis** i **Usuń wpis**. Usunięcie zawsze prosi o potwierdzenie; nie da się go cofnąć.
